import React from "react";
import { AlertPopUp, MessageAlert, AlertPopUpPrimary } from "./styles";

export function AlertMessage(props) {
  return (
    <AlertPopUp
      title={props.title}
      visible={props.visible}
      onCancel={props.onCancel}
      width={props.width}
      cancelText="CLOSE"
    >
      {props.children}
    </AlertPopUp>
  );
}

export function AlertMessagePrimary(props) {
  return (
    <AlertPopUpPrimary
      title={props.title}
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      width={props.width}
      cancelText="No,take me back"
      okText="CONTINUE"
    >
      {props.children}
    </AlertPopUpPrimary>
  );
}

export function MessagePopUp(props) {
  return (
    <MessageAlert
      title={props.title}
      visible={props.visible}
      onCancel={props.onCancel}
      width={props.width}
      cancelText="CLOSE"
    >
      {props.children}
    </MessageAlert>
  );
}

